import React from "react";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";

const MegaprojectsItem = ({ item }) => {
  const getStatusColor = (statusType) => {
    switch (statusType) {
      case "construction":
        return { backgroundColor: "#007bff", color: "white" }; // Blue
      case "progress":
        return { backgroundColor: "#ffc107", color: "black" }; // Yellow
      case "final":
        return { backgroundColor: "#28a745", color: "white" }; // Green
      case "planning":
        return { backgroundColor: "#17a2b8", color: "white" }; // Light blue
      case "concept":
        return { backgroundColor: "#6c757d", color: "white" }; // Gray
      default:
        return { backgroundColor: "#6c757d", color: "white" };
    }
  };

  const statusStyle = getStatusColor(item.statusType);

  return (
    <div
      className="megaproject-card"
      style={{
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "25px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        padding: "1.5rem",
        minHeight: "400px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        margin: "0 0.5rem"
      }}
    >
      {/* Header */}
      <div>
        <h3 
          className="text-white mb-3"
          style={{ 
            fontSize: "1.2rem", 
            fontWeight: "bold",
            lineHeight: "1.3"
          }}
        >
          {item.title}
        </h3>

        {/* Status Badge */}
        <div 
          className="status-badge mb-3"
          style={{
            ...statusStyle,
            padding: "0.25rem 0.75rem",
            borderRadius: "15px",
            fontSize: "0.8rem",
            fontWeight: "bold",
            display: "inline-block"
          }}
        >
          {item.status}
        </div>

        {/* Location and Year */}
        <div className="location-year mb-3">
          <div className="d-flex align-items-center mb-2">
            <FaMapMarkerAlt className="text-info me-2" style={{ fontSize: "0.9rem" }} />
            <span className="text-light" style={{ fontSize: "0.9rem" }}>{item.location}</span>
          </div>
          <div className="d-flex align-items-center">
            <FaCalendarAlt className="text-info me-2" style={{ fontSize: "0.9rem" }} />
            <span className="text-light" style={{ fontSize: "0.9rem" }}>{item.year}</span>
          </div>
        </div>

        {/* Description */}
        <p 
          className="text-light mb-3"
          style={{ 
            fontSize: "0.9rem", 
            lineHeight: "1.5"
          }}
        >
          {item.description}
        </p>

        {/* Category */}
        <div 
          className="category mb-3"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            padding: "0.5rem 0.75rem",
            borderRadius: "10px",
            fontSize: "0.8rem",
            color: "#17a2b8",
            fontWeight: "500",
            display: "inline-block"
          }}
        >
          {item.category}
        </div>
      </div>

      {/* Footer - Cost */}
      <div 
        className="cost text-info text-end"
        style={{ 
          fontSize: "1.1rem", 
          fontWeight: "bold",
          marginTop: "auto"
        }}
      >
        {item.cost}
      </div>
    </div>
  );
};

export default MegaprojectsItem;
